// Campus photo for /colleges/claremont-mckenna-college: CC BY-SA 4.0, by Sdkb, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AClaremont_McKenna_College_campus%2C_looking_east_toward_the_Bauer_Center.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/claremont-mckenna-college/; credited under the photo.
const photo = {
    "slug": "claremont-mckenna-college",
    "alt": "The Claremont McKenna College campus looking east toward the Bauer Center in Claremont, California",
    "src": "/colleges/claremont-mckenna-college/campus-1600.webp",
    "srcSmall": "/colleges/claremont-mckenna-college/campus-800.webp",
    "srcMid": "/colleges/claremont-mckenna-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/claremont-mckenna-college/og.jpg",
    "title": "Claremont McKenna College campus, looking east toward the Bauer Center",
    "author": "Sdkb",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AClaremont_McKenna_College_campus%2C_looking_east_toward_the_Bauer_Center.jpg",
    "read": "2026-10-01"
};

export default photo;
